import React, { useState } from "react";
import { ModalSearchNangCaoMobileXuatHoaDon } from "./ModalSearchNangCaoMobileXuatHoaDon";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";

export const SearchBarMobileXuatHoaDon = ({ dataSearch, onChange, onSearch, isHoaHongTraGop }) => {
  const [show, setShow] = useState(false);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") onSearch();
  };

  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right search-p mb-1" style={{ width: "100%" }}>
                <div className="row col-sm-12">
                  <div className="col-sm-8">
                    <div className="search-mobile-new">
                      <fieldset className="form-group position-relative mb-0">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Mã hợp đồng, tên khách hàng"
                          value={dataSearch.ten}
                          onChange={(e) => onChange("ten", e.target.value)}
                          onKeyDown={handleKeyDown}
                        />
                        <div className="form-control-position" onClick={onSearch}>
                          <i className="mdi mdi-magnify"></i>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <a
                      href={() => false}
                      className="card-link blue darken-2 text-search-new"
                      style={{ marginBottom: "-3px" }}
                      onClick={() => setShow(true)}
                    >
                      <i>
                        <PopoversBootrap contentText="Tìm kiếm nâng cao" trigger={["hover", "focus"]} placement={"top"}>
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-fitter-v2.png"
                            alt=""
                            style={{ scale: "0.9", verticalAlign: "sub", marginTop: "-2px" }}
                          />
                        </PopoversBootrap>
                      </i>
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {show && (
          <ModalSearchNangCaoMobileXuatHoaDon
            show={show}
            onHide={() => setShow(false)}
            dataSearch={dataSearch}
            onChange={onChange}
            onSearch={onSearch}
            isHoaHongTraGop={isHoaHongTraGop}
          />
        )}
      </div>
    </>
  );
};
